'use client'

import { useSession } from 'next-auth/react'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

export const SessionWatcher = () => {
  const { data: session } = useSession()
  const router = useRouter()

  useEffect(() => {
    if (session?.error === 'RefreshAccessTokenError') {
      console.warn('세션 만료 → 자동 로그아웃')
      router.push('/logout')
    }
  }, [session])

  return null
}
